import React, { useState } from 'react';
import { FaEdit, FaTrash, FaPlus } from 'react-icons/fa';
import { MdAdd } from 'react-icons/md';
import '../Styles/UserTypes.css';
import '../Styles/PopupModal.css';
import { useSidebar } from '../Layout/SidebarContext';

const UserTypes = () => {
  const { isConfigOpen } = useSidebar();

  const [userTypes, setUserTypes] = useState([
    {
      id: 1,
      role: 'AWS Account Manager',
      description: 'Administrator Role',
      createdBy: 'Mohan',
      createdDate: '15-Mar-2021',
      editedBy: 'Ameena',
      editedDate: '13-Jun-2024',
    },
    {
      id: 2,
      role: 'Neviton',
      description: 'Manager Role',
      createdBy: 'Ananya',
      createdDate: '12-Jan-2022',
      editedBy: 'Chandini',
      editedDate: '10-Jun-2024',
    },
  ]);

  const [searchTerm, setSearchTerm] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [userTypesInput, setUserTypesInput] = useState(['']);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [editRole, setEditRole] = useState('');
  const [editDescription, setEditDescription] = useState('');
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);

  const handleSearchChange = (e) => setSearchTerm(e.target.value);

  const handleAddNew = () => setIsModalOpen(true);

  const handleModalClose = () => {
    setUserTypesInput(['']);
    setIsModalOpen(false);
  };

  const handleSaveNew = () => {
    if (userTypesInput.length > 0) {
      const newUserTypes = userTypesInput.map((userType) => ({
        id: userTypes.length + 1,
        role: userType,
        description: 'New User Type',
        createdBy: 'Admin',
        createdDate: new Date().toLocaleDateString(),
        editedBy: 'Admin',
        editedDate: new Date().toLocaleDateString(),
      }));

      setUserTypes([...userTypes, ...newUserTypes]);
      setUserTypesInput(['']);
      setIsModalOpen(false);
    }
  };

  const handleEditUserType = (index) => {
    const userType = userTypes[index];
    setEditRole(userType.role);
    setEditDescription(userType.description);
    setEditIndex(index);
    setEditModalOpen(true);
  };

  const handleSaveEdit = () => {
    const updatedUserTypes = [...userTypes];
    updatedUserTypes[editIndex] = {
      ...updatedUserTypes[editIndex],
      role: editRole,
      description: editDescription,
      editedBy: 'Admin',
      editedDate: new Date().toLocaleDateString(),
    };
    setUserTypes(updatedUserTypes);
    setEditModalOpen(false);
  };

  const handleDeleteUserType = (index) => {
    setDeleteIndex(index);
    setConfirmDelete(true);
  };

  const handleConfirmDelete = () => {
    const newUserTypes = userTypes.filter((_, index) => index !== deleteIndex);
    setUserTypes(newUserTypes);
    setConfirmDelete(false);
    setDeleteIndex(null);
  };

  const handleCancelDelete = () => {
    setConfirmDelete(false);
    setDeleteIndex(null);
  };

  const filteredUserTypes = userTypes.filter(
    (user) =>
      user.role.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.description.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className={`user-types-container ${isConfigOpen ? 'shifted-right' : ''}`}>
      <div className='heading'>
        <h2>Manage User Types</h2>
        <div className="search-container">
          <input
            type="text"
            placeholder="Search User Types"
            value={searchTerm}
            onChange={handleSearchChange}
          />
        </div>
      </div>

      <table className="user-types-table">
        <thead>
          <tr>
            <th>
              <MdAdd size={24} color="#1e3c72" onClick={handleAddNew} />
            </th>
            <th>User Types</th>
            <th>Description</th>
            <th>Created By</th>
            <th>Created Date</th>
            <th>Edited By</th>
            <th>Edited Date</th>
          </tr>
        </thead>
        <tbody>
          {filteredUserTypes.map((userType, index) => (
            <tr key={userType.id}>
              <td>
                <FaEdit
                  size={15}
                  style={{ cursor: 'pointer', color: '#00bfa5' }}
                  onClick={() => handleEditUserType(index)}
                />
                <FaTrash
                  size={15}
                  color="#f44336"
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleDeleteUserType(index)}
                />
              </td>
              <td>{userType.role}</td>
              <td>{userType.description}</td>
              <td>{userType.createdBy}</td>
              <td>{userType.createdDate}</td>
              <td>{userType.editedBy}</td>
              <td>{userType.editedDate}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {editModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Edit User Type</h3>
          
              <input
                type="text"
                value={editRole}
                onChange={(e) => setEditRole(e.target.value)}
              />
        
            <div className="modal-actions">
              <button onClick={handleSaveEdit}>Save</button>
              <button onClick={() => setEditModalOpen(false)}>Close</button>
            </div>
          </div>
        </div>
      )}

      {confirmDelete && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Are you sure you want to delete this user type?</h3>
            <div className="modal-actions">
              <button onClick={handleConfirmDelete}>Yes, Delete</button>
              <button onClick={handleCancelDelete}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {isModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Add New User Type</h3>
            <div className="user-type-input-container">
              <input
                placeholder='Enter User Type'
                type="text"
                value={userTypesInput[0]} // Only the first input is used
                onChange={(e) => {
                  const updatedUserTypes = [...userTypesInput];
                  updatedUserTypes[0] = e.target.value; // Update only the first input
                  setUserTypesInput(updatedUserTypes);
                }}
              />
            </div>
            <div className="modal-actions">
              <button onClick={handleSaveNew}>Save</button>
              <button onClick={handleModalClose}>Close</button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default UserTypes;
